import { DisconnectButtonProps, useDisconnectButton } from "@livekit/components-react"
import React from "react"
import BaseButton from "./BaseButton"
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined'




const DisconnectSurveyButton: (
  props: DisconnectButtonProps & React.RefAttributes<HTMLButtonElement>
) => React.ReactNode = /* @__PURE__ */ React.forwardRef<HTMLButtonElement, DisconnectButtonProps>(
  function DisconnectSurveyButton(props: DisconnectButtonProps) {
    const { buttonProps } = useDisconnectButton(props)
    return (
      <BaseButton onClick={buttonProps.onClick} className={'control-exit-button '}>
        <StopCircleOutlinedIcon />
      </BaseButton>
    )
  }
)

export default DisconnectSurveyButton